<ng-template #statWidgets>
  <div
    class="stat-content flex-grow-1 w-100"
    style="cursor: pointer;"
    [attr.data-bs-toggle]="'tooltip'"
    data-bs-title="View triggered alerts"
    (click)="navigateToTriggeredAlerts()"
  >
    <div class="row g-3 m-0 stat-row-no-gutter">
      @for (stat of statData; track $index) {
        <div
          class="stat-box flex-grow-1 d-flex"
          [ngStyle]="{
            'min-width': '250px',
            flex: '1 1 calc(100% / ' + maxWidgetsPerRow + ' - 1rem)'
          }"
        >
          <app-stat-tile
            [accentColour]="stat.iconColour ?? 'primary'"
            [caption]="stat.subTitle"
            class="flex-grow-1 h-100"
            [decimalPlaces]="stat.decimalPlaces ?? 0"
            [icon]="'bx ' + stat.icon"
            [label]="stat.title ?? ''"
            [loading]="stat.loading"
            [prefix]="stat.prefix"
            [suffix]="stat.unit"
            [trendPercent]="trendPercent(stat)"
            [trendUpIsGood]="stat.profitUpIsGood ?? true"
            [value]="stat.value ?? null"
          ></app-stat-tile>
        </div>
      }
    </div>
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded ss-grey-panel">
          <div class="row">
            <div class="col-12">
              <div
                class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                role="alert"
              >
                <strong>{{containerTitle}}</strong>
                <div class="d-flex align-items-center" style="gap: 6px;">
                  <span
                    *ngIf="!expandContainer && showTitleHintText"
                    class="text-muted"
                    style="font-size: 0.85em;"
                  >
                    Widget Row
                  </span>
                  <i class="fs-5"
                     [attr.data-bs-toggle]="'tooltip'"
                     [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     [attr.data-bs-toggle]="'tooltip'"
                     data-bs-title="Close"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>
  
          @if (expandContainer) {
            <div class="row">
              <div class="col-12">
                <div class="mb-2 w-100">
                  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
}
